export const LockIcon = () => {
    return (
        <svg width="15" height="18" viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg" className="fill-black dark:fill-white">
            <path
                d="M12 6C13.66 6 15 7.34 15 9V17C15 18.66 13.66 20 12 20H3C1.34 20 0 18.66 0 17V9C0 7.34 1.34 6 3 6V4.5C3 2 5 0 7.5 0C10 0 12 2 12 4.5V6ZM3 7C1.9 7 1 7.9 1 9V17C1 18.1 1.9 19 3 19H12C13.1 19 14 18.1 14 17V9C14 7.9 13.1 7 12 7H3ZM11 6V4.5C11 2.57 9.43 1 7.5 1C5.57 1 4 2.57 4 4.5V6H11ZM7.5 12C6.67 12 6 12.67 6 13.5C6 14.33 6.67 15 7.5 15C8.33 15 9 14.33 9 13.5C9 12.67 8.33 12 7.5 12ZM7.5 11C8.88 11 10 12.12 10 13.5C10 14.88 8.88 16 7.5 16C6.12 16 5 14.88 5 13.5C5 12.12 6.12 11 7.5 11Z"
            />
        </svg>
    );
};
